/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import VModal from 'vue-js-modal';

import VTooltip from 'v-tooltip';
import EventHub from './EventHub';

require('./bootstrap');
require('./commonUtil');

/* eslint import/no-extraneous-dependencies: 0 */
window.Vue = require('vue');
window.zxcvbn = require('zxcvbn');

/* eslint no-undef: 0 */
Vue.use(VModal);
Vue.use(EventHub);
Vue.use(VTooltip);

/// //////////////////////////////////////////////
// コンポーネント
/// //////////////////////////////////////////////

/// //////////////////////////////////////////////
// フィルター
/// //////////////////////////////////////////////
